<template>
  <v-app>
    <v-app-bar
      app
      dense
      color="primary"
      dark
      elevate-on-scroll
    >
      <v-spacer></v-spacer>
      <v-img
        alt="Vardi"
        class="shrink"
        contain
        src="@/assets/logo1.png"
        max-height="32"
        width="200"
      />
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>
    <v-footer
        padless
        inset
        light
        class="mt-0 lighten-3">
      <v-col md="12" class="today-medium text-center primary--text text-decoration-none pa-1 gray text-caption" >
        Copyright © {{ new Date().getFullYear() }} VARDI INVERSIONES. Desarrollado por <a href="https://bio.credit/" class="text-decoration-none" target="_blank">BioCredit</a>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style>

.v-dialog {
  border-radius: 10px !important;
}

.v-text-field--outlined {
  border-radius: 6px !important;
}

.v-text-field--outlined fieldset {
  border-color: #00205B !important;
}

.theme--light.v-label {
  color: #00205B !important;
}

.v-toolbar__content {
  justify-content: center !important;
}

.wrap-text {
  white-space: normal;
  line-height: 110% !important;
}

.v-btn {
  letter-spacing: 0 !important;
}

.fill-height {
  margin-top: 0 !important;
}

@media (min-width: 1264px) {
  /* Vuetify 2 renders v-row as .row, not .v-row */
  .row.fill-height {
    --left-pane-width: clamp(
      15%,
      calc((100vh - 48px) * var(--left-image-ratio, 0.7077)),
      40%
    );
    align-items: stretch;
    display: flex;
    flex-wrap: nowrap !important;
    margin: 0 !important;
  }

  .row.fill-height > .bg-image {
    align-self: flex-start;
    background-position: left top;
    background-size: cover;
    flex: 0 0 var(--left-pane-width) !important;
    height: calc(100vh - 48px);
    max-height: 100%;
    max-width: 40% !important;
    min-width: 15% !important;
    padding: 0 !important;
    position: sticky;
    top: 0;
    width: var(--left-pane-width) !important;
  }

  .row.fill-height:not(.split-view__row) > .bg-image ~ .col {
    flex: 1 1 auto !important;
    max-width: none !important;
    min-width: 60%;
    overflow-y: auto;
    padding: 0 !important;
  }
}

</style>
